export default {
  evaluation_dashboard: {
    title: 'Bảng điều khiển cho bên mua',
    unit: ' Các công ty',
    average: 'Điểm trung bình:',
    point: ' Điểm',
    answered_label: 'Đã gửi',
    evaluated_label: 'Đã đánh giá',
    corporate_average: 'Điểm trung bình của nhà cung cấp',
    points_earned_by_companies: 'Phân bố điểm của nhà cung cấp',
    year_modal: {
      title: 'Chọn năm',
      label: 'Năm',
    },
    response_status_title: 'Phân bố trạng thái trả lời',
    response_status_rating_nothing: 'Chưa có câu trả lời nào',
    esg_rating_title: 'Phân bố xếp hạng ESG',
    esg_score_title: 'Phân bố điểm ESG',
    category_scores_title: 'So sánh điểm theo danh mục',
    category_scores_distribution_title: 'Phân bố điểm ESG theo danh mục',
    category_score_data_all_label: 'Điểm trung bình của ASUENE ESG',
    esg_scores_by_industry_title: 'Phân bố điểm ESG theo ngành',
    environment_score_title: 'Phân bố điểm môi trường',
    social_score_title: 'Phân bố điểm xã hội',
    governance_score_title: 'Phân bố điểm quản trị',
    environment_score_subtitle_upper5: 'Tốp 5 có điểm môi trường cao nhất',
    environment_score_subtitle_lower5: 'Tốp 5 có điểm môi trường thấp nhất',
    social_score_subtitle_upper5: 'Tốp 5 có điểm xã hội cao nhất',
    social_score_subtitle_lower5: 'Tốp 5 có điểm xã hội thấp nhất',
    governance_score_subtitle_upper5: 'Tốp 5 có điểm quản trị cao nhất',
    governance_score_subtitle_lower5: 'Tốp 5 có điểm quản trị thấp nhất',
    // empty_error_message: "",
    common: {
      companies: ' Các công ty',
      update_date: 'Ngày cập nhật lần cuối',
    },
    registration_rate: {
      title: 'Tỷ lệ đăng ký',
      tip: 'Các công ty đã đăng ký ở ASUENE ESG trong tổng số các công ty được đánh giá',
    },
    answer_rate: {
      title: 'Tỷ lệ nộp',
      tip: 'Các công ty đã nộp khảo sát trong tổng số các công ty được đánh giá',
    },
    days_remaining: {
      title: 'Số ngày còn lại cho đến khi kết thúc khảo sát',
      tip: 'Số ngày còn lại cho đến hạn chót đã định.\nNếu bạn muốn thay đổi hạn chót, vui lòng liên hệ với chúng tôi.',
      days_remaining_before: 'Còn lại',
      days_remaining_after: 'ngày',
      expired: 'Đã quá hạn chót.',
    },
    answer_transition: {
      title: 'Xu hướng nộp',
      companies_submitted: 'Các công ty đã nộp',
      breakdown: 'Bản phân tích',
      unregistered: 'Chưa đăng ký',
      total: 'Tổng số',
      number_of_companies: 'Số lượng công ty',
    },
    answer_list: {
      title: 'Lần nộp mới nhất',
      submitted_at: 'Ngày gửi',
    },
  },
}
